import { FC, ReactElement } from "react";
import { Navigate } from "react-router-dom";

import { useAppSelector } from "@/store";

interface IPublicRoute {
  component: ReactNode;
}

const PublicRoute: FC<IPublicRoute> = ({
  component: Component,
  ...rest
}): ReactElement => {
  const { user } = useAppSelector((state) => state.auth);

  if (user) {
    return <Navigate to={`/`} replace />;
  }

  return <Component {...rest} />;
};

export default PublicRoute;
